var map = {
	"./0/data.json": 856,
	"./1/data.json": 813,
	"./10/data.json": 8909,
	"./11/data.json": 1144,
	"./12/data.json": 7479,
	"./13/data.json": 6058,
	"./14/data.json": 1041,
	"./15/data.json": 8604,
	"./16/data.json": 3835,
	"./17/data.json": 8702,
	"./18/data.json": 1397,
	"./19/data.json": 4896,
	"./2/data.json": 3962,
	"./20/data.json": 9984,
	"./21/data.json": 1413,
	"./3/data.json": 9751,
	"./4/data.json": 2748,
	"./5/data.json": 4369,
	"./6/data.json": 8830,
	"./7/data.json": 2395,
	"./8/data.json": 64,
	"./9/data.json": 9957
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1009;